export { BarraDeProgressoDoCurso } from './barra-de-progresso-do-curso.component'
export * from './barra-de-progresso-do-curso.props'
